import script from "./OrderAdmin.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderAdmin.vue?vue&type=script&setup=true&lang=js"

import "./OrderAdmin.vue?vue&type=style&index=0&id=451de536&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-451de536"]])

export default __exports__